import { useState, useEffect, useContext } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import { Box } from "@mui/material";
import { Card } from "@mui/material";
import {
  boxStyle,
  StyledTableCell,
  StyledTableRow,
  buttonPosition2,
  searchStyle,
} from "../style/style";

import { loginContext } from "../context/contexts";
import { getKeyByValue } from "../context/contextmanager";
import { getobj } from "../apicall/apicall";
import AddUser from "./AddUser";
import { Root, headerStyle } from "../style/style";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { TextField } from "@mui/material";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import Pagination from "@mui/material/Pagination";
import { MenuItem } from "@mui/material";
import "react-notifications/lib/notifications.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { dltobj, updateobj } from "../apicall/apicall";

export default function UserList() {
  const [users, setusers] = useState([]);
  const [adduser, setadduser] = useState(false);
  const [search, setsearch] = useState(
    sessionStorage.getItem("search") ? sessionStorage.getItem("search") : "",
  );
  const [loaded, setloaded] = useState(true);
  const context = useContext(loginContext);
  const [page, setpage] = useState(
    sessionStorage.getItem("page_org")
      ? parseInt(sessionStorage.getItem("page_org"))
      : 1,
  );
  const [selectedAction, setselectedAction] = useState("");
  const [totalpage, setpaget] = useState();
  const [refresh, setrefresh] = useState(false);

  const handleaction = (id, val) => {
    //console.log(id, val);
    if (val === "Detail") {
      sessionStorage.setItem("page_org", page);
      handleDetail(id);
    }
    const url = process.env.REACT_APP_ZEWA_URL + "user/add-customer/";
    if (val === "Delete") {
      dltobj(url, { id: id }).then((r) => {
        if (r.status === 200) {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success("Successfully deleted.", "Deleted", 2000);
          setrefresh(!refresh);
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error(r.Message, "Failed", 2000);
        }
      });
    } else if (val === "Activate" || val === "Deactivate") {
      let status;
      if (val === "Activate") {
        status = true;
      } else {
        status = false;
      }
      const data = { id: id, active: status };

      updateobj(url, data)
        .then((res) => {
          NotificationManager.remove(NotificationManager.listNotify[0]);
          if (res.status === 200) {
            NotificationManager.success(res.Message, "Updated", 2000);
            setrefresh((prev) => !prev);
          } else {
            NotificationManager.error(res.Message, "Update Failed", 2000);
          }
        })
        .catch((err) => {
          NotificationManager.remove(NotificationManager.listNotify[0]);
          NotificationManager.error("Update failed.", "Error", 2000);
        });
      return;
    }
  };

  const handleSearch = (e) => {
    setloaded(true);

    setpage(1);
    e.preventDefault();
    if (e.target.value === "") {
      setrefresh(!refresh);
      sessionStorage.removeItem("search");
    } else {
      const url =
        process.env.REACT_APP_ZEWA_URL +
        "user/customer-list/?search=" +
        search +
        "&role=CUSTOMER";
      const d = getobj(url);
      d.then(function (res) {
        if (res && res.results) {
          setusers(res.results);
          if (res.count % 5 > 0) {
            setpaget(Math.floor(res.count / 5) + 1);
          } else {
            setpaget(Math.floor(res.count / 5));
          }
          sessionStorage.setItem("search", search);
        } else {
          console.error("Invalid response structure:", res);
          setusers([]);
        }
        setloaded(false);
      }).catch((err) => {
        console.error("Error during search:", err);
        setusers([]);
        setloaded(false);
      });
    }
  };
  const handlePagechange = (event, value) => {
    setloaded(true);
    setpage(value);
    let url =
      process.env.REACT_APP_ZEWA_URL +
      "user/customer-list/?page=" +
      value +
      "&role=CUSTOMER";
    if (search !== "") {
      url =
        process.env.REACT_APP_ZEWA_URL +
        "user/customer-list/?page=" +
        value +
        "&role=CUSTOMER&search=" +
        search;
    }

    const d = getobj(url);
    d.then(function (res) {
      if (res && res.results) {
        setusers(res.results);
      } else {
        console.error("Invalid response structure:", res);
        setusers([]);
      }
      setloaded(false);
    }).catch((err) => {
      console.error("Error fetching page:", err);
      setusers([]);
      setloaded(false);
    });
  };

  const handleClick = () => {
    setadduser(!adduser);
  };

  const handleDetail = (id) => {
    context.setid(id);
    context.setcustomer_id(id);
    const nm = getKeyByValue(context.page, true);
    context.setpage({
      ...context.page,
      [nm]: false,
      userDetail: true,
    });
  };

  useEffect(() => {
    let url = "";
    if (search.length > 0) {
      url =
        process.env.REACT_APP_ZEWA_URL +
        "user/customer-list/?search=" +
        search +
        "&role=CUSTOMER&page=" +
        page;
    } else {
      url =
        process.env.REACT_APP_ZEWA_URL +
        "user/customer-list/?page=" +
        page +
        "&role=CUSTOMER";
    }
    const d = getobj(url);
    d.then(function (res) {
      if (res && res.results) {
        setusers(res.results);
        if (res.count % 5 > 0) {
          setpaget(Math.floor(res.count / 5) + 1);
        } else {
          setpaget(Math.floor(res.count / 5));
        }
      } else {
        console.error("Invalid response structure:", res);
        setusers([]);
      }
      setloaded(false);
    }).catch((err) => {
      console.error("Error fetching user list:", err);
      setusers([]);
      setloaded(false);
    });
  }, [adduser, refresh, search, page]);
  return (
    <Root>
      {loaded ? (
        <img
          src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif"
          alt="loading..."
        />
      ) : (
        <Root>
          <Card sx={boxStyle}>
            <Card sx={headerStyle}>
              {adduser ? "Add Organization" : "Organization List"}
              {!adduser && (
                <form style={searchStyle} onSubmit={handleSearch}>
                  <FormControl variant="standard" sx={searchStyle}>
                    <InputLabel htmlFor="input-with-icon-adornment">
                      Search Organization
                    </InputLabel>
                    <Input
                      id="input-with-icon-adornment"
                      startAdornment={
                        <InputAdornment position="start">
                          <SearchSharpIcon color="primary" />
                        </InputAdornment>
                      }
                      value={search}
                      onChange={(e) => {
                        setsearch(e.target.value);
                        if (e.target.value === "") {
                          handleSearch(e);
                        }
                      }}
                    />
                  </FormControl>
                </form>
              )}
            </Card>
          </Card>

          <Box sx={boxStyle}>
            {!adduser && (
              <Box
                m={2}
                //margin
                sx={!adduser && buttonPosition2}
              >
                <Button
                  variant={!adduser && "contained"}
                  color={!adduser && "primary"}
                  startIcon={!adduser && <PersonAddAltIcon />}
                  onClick={handleClick}
                >
                  {!adduser && "Add Organization"}
                </Button>
              </Box>
            )}
            {!adduser ? (
              <TableContainer component={Paper}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>
                        <b>Company Name</b>
                      </StyledTableCell>
                      <StyledTableCell>
                        <b>Name</b>
                      </StyledTableCell>

                      <StyledTableCell>
                        <b>Email</b>
                      </StyledTableCell>
                      <StyledTableCell>
                        <b>Phone</b>
                      </StyledTableCell>
                      <StyledTableCell>
                        <b>Status</b>
                      </StyledTableCell>
                      <StyledTableCell>
                        <b>Data forwarding status</b>
                      </StyledTableCell>
                      <StyledTableCell>
                        <b>Distributor</b>
                      </StyledTableCell>
                      <StyledTableCell></StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {users &&
                      users.map((user) => (
                        <StyledTableRow key={user.id}>
                          <StyledTableCell>{user.company_name}</StyledTableCell>
                          <StyledTableCell>
                            {user.first_name !== ""
                              ? user.customer_first_name +
                                " " +
                                user.customer_last_name
                              : user.email.split("@")[0]}
                          </StyledTableCell>

                          <StyledTableCell>
                            {user.customer_email}
                          </StyledTableCell>
                          <StyledTableCell>
                            {user.phone !== "0"
                              ? user.customer_phone_number
                              : "NA"}
                          </StyledTableCell>
                          <StyledTableCell>
                            {user.active_status ? "Active" : "Inactive"}
                          </StyledTableCell>
                          <StyledTableCell>
                            {user.data_forwarding_status === false
                              ? "OFF"
                              : "ON"}
                          </StyledTableCell>
                          <StyledTableCell>{user.distributor}</StyledTableCell>
                          <StyledTableCell>
                            <Button>
                              <TextField
                                select
                                name="user_list"
                                id="deviceName"
                                sx={{ width: "clamp(80px, 12vw, 100px)" }}
                                variant="outlined"
                                label="Action"
                                value={selectedAction}
                                onChange={(e) => {
                                  if (e.target.value === "Detail") {
                                    handleaction(
                                      user.customer_id,
                                      e.target.value,
                                    );
                                  } else {
                                    handleaction(
                                      user.customer_id,
                                      e.target.value,
                                    );
                                  }
                                  setselectedAction("");
                                }}
                              >
                                <MenuItem value="Detail">Detail</MenuItem>
                                <MenuItem
                                  value={
                                    user.active_status
                                      ? "Deactivate"
                                      : "Activate"
                                  }
                                >
                                  {user.active_status
                                    ? "Deactivate"
                                    : "Activate"}
                                </MenuItem>
                                <MenuItem value="Delete">Delete</MenuItem>
                              </TextField>
                            </Button>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                  </TableBody>
                </Table>
                <Pagination
                  count={totalpage}
                  page={page}
                  variant="outlined"
                  color="primary"
                  onChange={handlePagechange}
                />
              </TableContainer>
            ) : (
              <AddUser setadduser={setadduser} />
            )}
          </Box>
          <NotificationContainer />
        </Root>
      )}
    </Root>
  );
}
